import NAME from "./constants";

export const GET_DATA = NAME + "/GET_DATA";
export const GET_DATA_FULFILLED = NAME + "/GET_DATA_FULFILLED";
export const GET_DATA_REJECTED = NAME + "/GET_DATA_REJECTED";

export const LIKE = NAME + "/LIKE";